import { Badge } from './ui/badge';
import { reviewIdentity } from '../lib/reviewCandidates';

export const ReviewRuntimeStatus = ({ rule, onScopeChange }) => {
  const key = reviewIdentity(rule);
  const active = rule.human_decision === 'confirmed' && rule.confirmed_rule_id;
  const pending = rule.user_selected && rule.runtime_support === 'engine_pending';
  return <div className="mt-2 space-y-2" onClick={event => event.stopPropagation()}>
    <div className="flex flex-wrap items-center gap-2 text-[11px]">
      <Badge variant="outline" data-testid={`review-ref-${key}`}>{rule.review_ref || rule.id}</Badge>
      <span className="font-mono break-all" data-testid={`review-source-id-${key}`}>{rule.candidate_rule_id || rule.id}</span>
      {rule.verifier_verdict && <span data-testid={`review-sol-${key}`}>Sol: {rule.verifier_verdict}</span>}
      {rule.gate_status && <span data-testid={`review-original-gate-${key}`}>Gate: {rule.gate_status}</span>}
      {rule.human_decision && <span data-testid={`review-human-${key}`}>BIM reviewer: {rule.human_decision}</span>}
      <span data-testid={`review-runtime-${key}`}>{active ? 'Runtime: active' : pending ? 'User selected · Engine support: pending' : `Runtime: ${rule.runtime_support || 'existing evaluator'}`}</span>
    </div>
    {rule.runtime_reason && <p className="text-xs text-muted-foreground" data-testid={`review-runtime-reason-${key}`}>{rule.runtime_reason}</p>}
    {rule.runtime_support === 'requires_scope' && rule.scope_options?.length > 0 && <div className="flex flex-wrap gap-3">
      {rule.scope_options.map(cls => <label key={cls} className="flex items-center gap-2 text-xs">
        <input type="checkbox" data-testid={`review-scope-${key}-${cls}`}
          checked={(rule.target_ifc_classes || []).includes(cls)}
          onChange={event => onScopeChange(key, event.target.checked
            ? [...(rule.target_ifc_classes || []), cls]
            : (rule.target_ifc_classes || []).filter(value => value !== cls))} />
        {cls}
      </label>)}
    </div>}
    {rule.review_outcome && <p className="text-xs" role="status" data-testid={`review-outcome-${key}`}>
      {rule.review_outcome.status}: {rule.review_outcome.reason || 'Saved'}
    </p>}
  </div>;
};